module.exports = __webpack_public_path__ + "images/pages/kaitori_bonus_cp_lp/6th/mainvisual-bg-left_53b8867f61373b228e9822fd186b9406.svg";